<template>
  <component :is="tag" :class="classes" :datetime="isoDate">
    {{printDate}}
  </component>
</template>

<script lang="ts">
  /* DATE EXAMPLE: October 13, 1996 05:35:32 GMT-3:00 */
  import Vue from "vue";
  import moment from "moment";

  export default Vue.extend({
    props: {
      tag: {
        type: String,
        default: 'time'
      },
      hasTime: {
        type: Boolean,
        default: false
      }
    },
    data: function() {
      return {
        inputDate: new Date(this.$slots.default[0].text)
      };
    },
    computed: {
      classes() {
        return [];
      },
      isoDate() {
        return this.inputDate.toISOString();
      },
      printDate() {
        let thisMoment = moment(this.inputDate);
        if(this.hasTime){
          return thisMoment.format("MMM Do, YYYY [at] h:mm a");
        } else {
          return thisMoment.format('MMM Do, YYYY');
        }
      }
    }
  });
</script>
